<script setup lang="ts">
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import OrganizerLpHeroSection from '@/components/marketing/organizers/OrganizerLpHeroSection.vue'
import OrganizerLpPillarsSection from '@/components/marketing/organizers/OrganizerLpPillarsSection.vue'
import OrganizerLpFeatureGridSection from '@/components/marketing/organizers/OrganizerLpFeatureGridSection.vue'
import OrganizerLpSpotlightsSection from '@/components/marketing/organizers/OrganizerLpSpotlightsSection.vue'
import OrganizerLpWebsiteSection from '@/components/marketing/organizers/OrganizerLpWebsiteSection.vue'
import OrganizerLpPricingSection from '@/components/marketing/organizers/OrganizerLpPricingSection.vue'
import OrganizerLpTrustSection from '@/components/marketing/organizers/OrganizerLpTrustSection.vue'
import OrganizerLpFaqSection from '@/components/marketing/organizers/OrganizerLpFaqSection.vue'
import OrganizerLpCtaBannerSection from '@/components/marketing/organizers/OrganizerLpCtaBannerSection.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <NavBar />
    <main class="flex-1">
      <OrganizerLpHeroSection />
      <OrganizerLpPillarsSection />
      <OrganizerLpFeatureGridSection />
      <OrganizerLpSpotlightsSection />
      <OrganizerLpWebsiteSection />
      <OrganizerLpPricingSection />
      <OrganizerLpTrustSection />
      <OrganizerLpFaqSection />
      <OrganizerLpCtaBannerSection />
    </main>
    <AppFooter />
  </div>
</template>
